// extracted by mini-css-extract-plugin
module.exports = {"group_all_modeSwitcher":"group_all_modeSwitcher--W2Ye2","text":"text--1L79t"};